import { render, staticRenderFns } from "./FollowHistory.vue?vue&type=template&id=680f5e76&scoped=true"
import script from "./FollowHistory.vue?vue&type=script&lang=js"
export * from "./FollowHistory.vue?vue&type=script&lang=js"
import style0 from "./FollowHistory.vue?vue&type=style&index=0&id=680f5e76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f5e76",
  null
  
)

export default component.exports